import { createContext, useContext } from 'react';

export type PatientProfileSurface = 'drawer' | 'full_page';

export const PatientProfileSurfaceContext = createContext<PatientProfileSurface | null>(
  null
);

export const usePatientProfileSurface = (): PatientProfileSurface =>
  useContext(PatientProfileSurfaceContext) ?? 'drawer';
